var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.activity !== null
            && this.route
            && this.route.currentStep
            && this.route.currentStep !== 'exercise/evaluation')?_c('Exercise',{key:_vm.componentKey,attrs:{"phase":_vm.phase,"challenge":_vm.challenge,"activity":_vm.activity,"activityIdx":_vm.activityIdx},on:{"next-activity":_vm.onEnded}}):(this.route
                  && this.route.currentStep === 'exercise/evaluation')?_c('Evaluation',{attrs:{"phase":_vm.phase,"challenge":_vm.challenge},on:{"next-activity":_vm.onFinishedChallenge}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }